import React from "react";
import PropTypes from "prop-types";

/**
 * PlainField - a labeled plain `<input>`, no @-token support. Used for decision_owner /
 * decision_deadline (short, name-or-date values where a figure mention makes no sense) -
 * distinct from TextField/SummaryField specifically so those two stay reserved for prose that
 * really can carry an inline figure. Extracted from NarrativeRail (SP6 Task 5).
 */
const PlainField = ({ label, value, onChange, disabled, placeholder, onFocus }) => (
  <label className="block">
    <span className="block text-xs font-medium text-text-2 mb-1">{label}</span>
    <input
      type="text"
      className="w-full px-2 py-1.5 border border-border rounded-ctrl text-xs bg-card text-text disabled:text-text-3"
      value={value || ""}
      disabled={disabled}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      onFocus={onFocus}
    />
  </label>
);

PlainField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  onFocus: PropTypes.func,
};

export default PlainField;
